import { safeHref } from '../helpers/safeHref';
import React, {Component} from 'react';
import {Button, Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Col, OverlayTrigger, Row, ToggleButton, ToggleButtonGroup, Tooltip} from "react-bootstrap";
import Moment from "react-moment";
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import { TbFileInvoice } from "react-icons/tb";

function getAffiliateList() {

    return fetch('https://back-api.therunningcollective.fr/affiliate-billings', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

export class AffiliateBillingList extends Component {
    state = {
        errors: null,
        csvUsers: null,
    }

    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    async componentDidMount() {
        await getAffiliateList().then(data => {
            const uniqueNames = data
            this.setState({users: uniqueNames})
        }).catch(err =>
            this.setState({errors: "error while getting users"})
        );
    };

    closeModal() {
        this.setState({isOpen: false, isOpenModify: false})
    } 


    render() {
        return (
            <div className="products-list">
                <Row>
                    <Col sm={9} className="products-buttons">
                        {(this.state.users && this.state.errors == null) ? <span>{this.state.users.length} facture(s)</span> : null }
                    </Col>
                </Row>

                { (!this.state.users && this.state.errors == null) ? <p> Chargement ...</p>
                    :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Nom</th>
                            <th>Prénom</th>
                            <th>Email</th>
                            <th>Total</th>
                            <th>Facture</th>
                            <th>Validée</th>
                            <th>Payée</th>
                            <th>Date paiement</th>
                        </tr>
                        </thead>
                        <tbody>
                            {this.state.users &&  this.state.users.map(user => (
                            <tr>
                                <td>
                                    <Moment locale="fr" format="DD-MM-YYYY à HH:mm">
                                        {user.creationDate}
                                    </Moment>
                                </td>
                                <td>{user.lastName}</td>
                                <td>{user.firstName}</td>
                                <td>{user.email}</td>
                                <td>{user.total}€</td>
                                <td><a href={safeHref(user.invoiceLink)} rel="noopener noreferrer" target='_blank'><TbFileInvoice size={20}/></a></td>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Facture prise en compte ?</Tooltip>}
                                >
                                    <td><BootstrapSwitchButton
                                        checked={user.validated}
                                        onlabel='oui'
                                        onstyle='success'
                                        offlabel='non'
                                        offstyle='danger'
                                        size='xs'
                                        onChange={(checked: boolean) => {
                                            updateValidatedState(user, checked)
                                        }}
                                    /></td>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Facture payée ?</Tooltip>}
                                >
                                    <td><BootstrapSwitchButton
                                        checked={user.payed}
                                        onlabel='oui'
                                        onstyle='success'
                                        offlabel='non'
                                        offstyle='danger'
                                        size='xs'
                                        onChange={(checked: boolean) => {
                                            updatePayedState(user, checked)
                                        }}
                                    /></td>
                                </OverlayTrigger>
                                <td>
                                    <Moment locale="fr" format="DD-MM-YYYY à HH:mm">
                                        {user.paymentDate}
                                    </Moment>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }
                
            </div>
        );

    }
}

function updateValidatedState(user, checked) {
    user.validated = checked
    return fetch('https://back-api.therunningcollective.fr/affiliate-billing', {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    }).then()
        .catch( err =>
            console.log(err)
        )
}

function updatePayedState(user, checked) {
    user.payed = checked
    return fetch('https://back-api.therunningcollective.fr/affiliate-billing', {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    }).then()
        .catch( err =>
            console.log(err)
        )
}
